<template>
	<div class="view news-detail-view" id="newsDetailView">
		<HeaderBar>
			<img v-if="!is_collect"
				 class="fav-img"
				 src="../../assets/images/unfav.png"
				 alt="收藏"
				 @click="onFavClick" />
			<img v-else
				 class="fav-img"
				 src="../../assets/images/fav2.png"
				 alt="取消收藏"
				 @click="onUnfavClick" />

			<img class="share-img"
				 src="../../assets/images/share.png"
				 alt="分享"
				 @click="shareVisible = true" />
		</HeaderBar>
		<div class="view__wrap" id="viewWrap">
			<div class="title">{{ title }}</div>
		<div class="author-info-wrap"
			 @click="onUserClick">
			<img v-if="!!avatar"
				 class="avatar"
				 :src="avatar" />
			<img v-else
				 class="avatar"
				 src="../../assets/images/default_avatar.png" />
			<div class="detail-info-wrap">
				<div class="name">{{ nickname }}</div>
				<div class="text--sub">{{ `${publish_date} · 文章来源：${source}` }}</div>
			</div>
		</div>
		<div class="intro-wrap" v-if="!!short_desc">{{short_desc}}</div>
		<div class="content-wrap"
			 v-html="content"></div>
		<div class="tag-wrap"
			 v-if="tagList.length > 0">
			<TagItem v-for="item in tagList"
					 :key="item.id"
					 :isRound="true"
					 v-bind="item" 
           :click="onTagClick"/>
		</div>
		<div class="declare-wrap text--sub" v-if="firstLoaded">
			本文内容仅代表作者个人观点，不代表友绿APP立场，本APP只提供参考不构成任何投资及应用建议。（若存在内容、版权或其他问题，请联系：jiangdr@igreen.org）
		</div>
		<div class="relative-wrap" v-if="firstLoaded">
			<div class="title">相关阅读</div>
			<NewsItem v-for="item in relNewsList"
					  :key="item.id"
					  v-bind="item" />
		</div>
		</div>
		
		<PopLoading v-show="isLoading" />
		<SharePanel v-show="shareVisible"
					@cancel="shareVisible = false;" :content="short_desc" :cover="cover" :title="title" :contentType="1" :dataType="1" />

	</div>
</template>

<script>
import { Toast } from 'mint-ui'

import apiConst from '../../consts/apiConst';
import apiUtil from '../../utils/apiUtil';
import HeaderBar from '../../components/HeaderBar';
import TagItem from '../../components/TagItem.vue';
import NewsItem from '../../components/NewsItem.vue';
import PopLoading from '../../components/PopLoading.vue';
import SharePanel from '../../components/SharePanel'

export default {
	name: 'newsDetail',
	components: {
		HeaderBar,
		TagItem,
		NewsItem,
		PopLoading,
		SharePanel,
		shareVisible: false,

	},
	data() {
		return {
			id: 0,
			avatar: '',
			cate_name: '',
			content: '',
			cover: '',
			nickname: '',
			publish_date: '',
			tagList: [],
			title: '',
			view: 0,
			is_collect: 0,
			action_id: 0,
			is_admin_publish: 0,
			source: '',
			short_desc: '',
			relNewsList: [],
			isLoading: false,
			shareVisible: false,
			firstLoaded: false
		};
	},
	created() {
		const id = this.$route.query.id;
		this.id = id;
		this.init(id);
	},

	watch: {
		'$route'(to, from) {
			const newId = to.query.id
			if (this.id !== newId) {
				this.init(newId)
				this.id = newId
				this.scrollToTop();
			}
		}
	},
	methods: {
		scrollToTop(){
			this.$nextTick(() => {
				setTimeout(() => {
					let scrollTop = this.$el.querySelector('#viewWrap');
					scrollTop.scrollTop = 0;
				}, 13)
			})
		},
		async init(id) {
			this.isLoading = true;
			const res = await apiUtil.post(apiConst.getNewsDetail, { news_id: id });
			this.isLoading = false;
			this.firstLoaded = true;
			if (res) {
				const {
					avatar,
					cate_name,
					content,
					cover,
					nickname,
					publish_date,
					tag,
					title,
					view,
					action_id,
					is_admin_publish,
					source,
					short_desc
				} = res.list;
				this.avatar = avatar;
				this.cate_name = cate_name;
				this.content = content;
				this.cover = cover;
				this.nickname = nickname;
				this.publish_date = publish_date;
				this.tagList = tag.map((ele, index) => {
						ele.name = ele.title;
						return ele;
					
				});
				this.title = title;
				document.title = this.title
				this.view = view;
				this.is_collect = res.is_collect;
				this.action_id = action_id;
				this.is_admin_publish = is_admin_publish;
				this.source = source;
				this.relNewsList = res.relation_news;
				this.short_desc = short_desc;
			}
		},

		async onFavClick() {
			const res = await apiUtil.post(apiConst.submitFav, {
				id: this.id,
				type: 1
			});
			if (res.success) {
				this.is_collect = 1;
				Toast({
					message: '收藏成功',
					duration: 1000,
					background: '#8FC31E'
				});
			}
		},

		async onUnfavClick() {
			const res = await apiUtil.post(apiConst.submitUnfav, {
				id: this.id,
				type: 1
			});
			if (res.success) {
				this.is_collect = 0;

				Toast({
					message: '已取消收藏',
					duration: 1000,
					background: '#8FC31E'
				});
			}
    },
    
    onTagClick(tag_id) {
      this.$router.push({ name: 'filtered', query: { tag_id } })
    },

		onUserClick() {
			this.$router.push({
				name: 'userCenter',
				query: {
					action_id: this.action_id,
					is_admin_publish: this.is_admin_publish
				}
			});
		},

		onShareClick() { }
	}
};
</script>
<style lang="stylus" scoped>
.news-detail-view {
	position: relative;
	height: 100%;


	.title {
		padding: 30px 36px 0;
		color: #333;
		font-size: 48px;
		font-weight: bold;
		line-height: 67px;
		margin-bottom: 46px;
		text-align: justify;
	}

	.author-info-wrap {
		padding: 0 36px 0;
		display: flex;
		align-items: center;
		margin-bottom: 36px;

		.avatar {
			width: 80px;
			height: 80px;
			border-radius: 50px;
			margin-right: 36px;
		}

		.detail-info-wrap {
			.name {
				font-size: 32px;
				font-weight: bold;
				color: #333;
				margin-bottom: 14px;
			}

			.text--sub{
				line-height: 40px;
			}
		}
	}

	.tag-wrap {
		padding: 0 36px 0;
		margin-bottom: 36px;

		.tag-item-comp {
			margin-right: 35px;
			margin-top:13px;
		}
	}

	.intro-wrap {
		width: 678px;
		padding: 27px 51px;
		border-radius: 8px;
		background-color: #F8F9FB;
		margin: auto;
		color: #333;
		font-size: 30px;
		line-height: 48px;
		font-weight: bold;
	}

	.content-wrap {
		padding: 0 36px 0;
		line-height: 60px;
		color: #333;
		font-size: 32px;
		text-align: justify;
	}

	.declare-wrap {
		border-top: 1PX solid #f1f1f1;
		padding: 18px 36px 0;
		line-height: 33px;
	}

	.relative-wrap {
		margin-top: 50px;
		padding: 0 10px 0;
		border-top: 10px solid #eee;

		.title {
			font-size: 32px;
			text-align: center;
			margin: 30px 0 0;
		}
	}
}
</style>

<style scoped>
.news-detail-view .content-wrap >>> img {
	max-width: 100% !important;
	height: auto !important;
	display: block;
	margin: auto;
}
.news-detail-view .content-wrap >>> a {
	word-break: break-all;
}

</style>





